/**
 * This safely parses the stringified json. It string is not a valid json, it returns undefined
 * @param objString
 * @returns Object | undefined
 */
export default (objString, ignoreLogging = false) => {
  try {
    return JSON.parse(objString)
  } catch (e) {
    !ignoreLogging && console.warn('unable to parse: ', objString)
  }
}
